var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"calc(100vh)","width":"100%","text-align":"left"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.landingCustom)}})])}
var staticRenderFns = []

export { render, staticRenderFns }